import classes from "./SearchBar.module.css"
import { useStateContext } from '../../context/StateContext';
import { useState, useEffect } from "react";

const SearchBar = () => {
    const [ query, setQuery ] = useState('')
    const { setSearchTerm } = useStateContext()
    
    // defer change of searchTerm while typing
    useEffect(() => {
        const timeout = setTimeout(() => {
            setSearchTerm(query);
        }, 100);
        return () => {
          clearTimeout(timeout);
        };
      }, [query, setSearchTerm]);
      


    const handleChange = (e) => {
        e.preventDefault()
        setQuery(e.target.value)
    }
    return (
        <>
            <input className={classes.searchBar} type="search" placeholder="Search..." onChange={handleChange}/>
        </>
    )
}

export default SearchBar
